export interface SwissStanding {
  participantId: string;
  tournamentId: string;
  points: number;
  matchesPlayed: number;
  wins: number;
  losses: number;
  draws: number;
  buchholz?: number; // Tiebreaker: sum of opponent scores
  sonnebornBerger?: number; // Tiebreaker: sum of (opponent score * match result)
  opponentIds: string[]; // Track who they've played against
}
